import React, { Fragment } from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    // agentlogo: {
    //     width: 74,
    //     height: 66,
    //     marginRight: 0,
    //     marginLeft: 400,
    // },
    logo: {
      width: 60,
      height: 50,
       marginBottom: -70,
  },
  agentname: {
     marginBottom: -90,
},
  });


  const AgentImage = ({invoice}) =>{
    var invoice1 = (JSON.stringify(invoice));
    var invoice2 = JSON.parse(invoice1);
    var invoice3 = JSON.parse(invoice2);
  
    return(
       <Fragment>
           <View>
           <Image style={styles.logo} src={invoice3?.agentdetails?.agentimageurl} />
           </View>
    </Fragment>
      );
 
   } 
   export default AgentImage